import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Box,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
} from '@mui/material';
import GradingIcon from '@mui/icons-material/Grading';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import EditNoteIcon from '@mui/icons-material/EditNote';
import WarningIcon from '@mui/icons-material/Warning';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { can } from '../../Conections/LogConections';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate, useParams } from 'react-router-dom';
import { GetActivitiesDataAPI, GetEstudentsDataAPI, GetGruopDataAPI } from '../../Conections/AcademicConection';

// Datos de ejemplo para el grupo
let grupoEjemplo = {
    id: '',
    nombre: '',
    descripcion: '',
    estado: true,
    estudiantes: [
        { id: '', codigo: '', nombre: '', apellido: '' },
    ],
    actividades: [
        { id: '0', nombre: '', peso: 0, fecha: '', activa: true },
    ]
};

function GroupShow() {

    const { getToken, getCompany } = useAuth();
    const goTo = useNavigate();
    const { id } = useParams();


    const [grupo, setGrupo] = useState(grupoEjemplo);
    const [grupoNombre, setGrupoNombre] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [estudianteARetirar, setEstudianteARetirar] = useState(null);
    const [actividadAEliminar, setActividadAEliminar] = useState(null);
    const [busqueda, setBusqueda] = useState('');

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/showgroup/:id");
                if (permisionCan === 1) {
                    let Gruop = await GetGruopDataAPI(getToken(), getCompany(), id);
                    let Estudents = await GetEstudentsDataAPI(getToken(), getCompany(), id);
                    let Activities = await GetActivitiesDataAPI(getToken(), getCompany(), id, -1);
                    Gruop = Gruop["gruop"];
                    let grupoC = grupo;
                    grupoC["id"] = id;
                    setGrupoNombre(Gruop["name"]);
                    grupoC["nombre"] = Gruop["name"];
                    grupoC["descripcion"] = Gruop["descripcion"];
                    grupoC["estado"] = Gruop["show"] === 1;

                    const listActivities = Activities.map(Activity => ({
                        id: Activity.id,
                        nombre: Activity.name,
                        peso: Activity.weigth,
                        fecha: Activity.date,
                        activa: (Activity.show === 1)
                    }));
                    grupoC["actividades"] = listActivities;

                    const listEstudents = Estudents.map(Estudent => ({
                        id: Estudent.id,
                        codigo: Estudent.code,
                        nombre: Estudent.firstname,
                        apellido: Estudent.lastname,
                        estado: Estudent.active === "1"
                    }));
                    grupoC["estudiantes"] = listEstudents;

                    setGrupo(grupoC);
                }
                else {
                    goTo("/dashboard");
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [id, getCompany, getToken, goTo, grupo, grupoNombre]);



    const handleOpenDialog = (estudiante) => {
        setEstudianteARetirar(estudiante);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEstudianteARetirar(null);
        setActividadAEliminar(null);
    };

    const handleRetirarEstudiante = () => {
        console.log(`Retirando estudiante: ${estudianteARetirar?.nombre} ${estudianteARetirar?.apellido}`);
        handleCloseDialog();
    };

    const handleVerNotas = (estudiante) => {
        window.open("/academic/estudentgrade/dataestudentdjsfieihfohufgryugdslufsdgyuyfgayuflgladsyfgeal/" + estudiante.codigo, "_blank", "noopener,noreferrer");
    };

    const handleEditStudent = (estudiante) => {
        goTo("/academic/editstudent/" + `${id}/${estudiante.id}`);
    };

    const filtrarEstudiantes = () => {
        return grupo.estudiantes.filter(estudiante =>
            estudiante.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
            estudiante.apellido.toLowerCase().includes(busqueda.toLowerCase()) ||
            String(estudiante.codigo).toLowerCase().includes(busqueda.toLowerCase())
        );
    };

    const handleEliminarActividad = (actividad) => {
        setActividadAEliminar(actividad);
        setOpenDialog(true);
    };

    const confirmarEliminarActividad = () => {
        setGrupo(prevGrupo => ({
            ...prevGrupo,
            actividades: prevGrupo.actividades.filter(act => act.id !== actividadAEliminar.id)
        }));
        handleCloseDialog();
    };

    const handleEditarActividad = (actividad) => {
        goTo("/academic/editactivity/" + id + "/"+ actividad.id);
    };

    const handleVerActividad = (actividad) => {
        goTo("/academic/showactivity/" + actividad.id);
    };

    const handleAddActivity = () => {
        goTo("/academic/createactivity/" + id);
    };

    const handleAddStudent = () => {
        goTo("/academic/createestudent/" + id);
    };

    const handleAddStudentArray = () => {
        goTo("/academic/registerestudent/" + id);
    };

    const handleEditar = (id) => {
        goTo("/academic/editgroup/"+id);
    };

    return (
        <Container component="main" maxWidth="md">
            <Typography component="h1" variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
                Consulta de Grupo
            </Typography>

            <Grid container spacing={3}>
                {/* Tarjeta de Información del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Información del Grupo
                            <IconButton onClick={() => handleEditar(id)} color="primary">
                                <DriveFileRenameOutlineIcon />
                            </IconButton>
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography>Nombre: {grupoNombre}</Typography>
                            <Typography>Descripción: {grupo.descripcion}</Typography>
                            <FormControlLabel
                                control={<Switch checked={grupo.estado} disabled />}
                                label={grupo.estado ? "Activo" : "Inactivo"}
                            />
                        </Box>
                    </Paper>
                </Grid>

                {/* Tarjeta de Actividades del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>Actividades del Grupo
                            <IconButton color="primary" onClick={handleAddActivity} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Typography>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell>Peso</TableCell>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Estado</TableCell>
                                        <TableCell align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {grupo.actividades.map((actividad) => (
                                        <TableRow key={actividad.id}>
                                            <TableCell>{actividad.nombre}</TableCell>
                                            <TableCell>{actividad.peso}%</TableCell>
                                            <TableCell>{actividad.fecha}</TableCell>
                                            <TableCell>
                                                <FormControlLabel
                                                    control={<Switch checked={actividad.activa} disabled />}
                                                    label={actividad.activa ? "Activa" : "Inactiva"}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <IconButton onClick={() => handleVerActividad(actividad)} color="primary">
                                                    <VisibilityIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleEditarActividad(actividad)} color="primary">
                                                    <EditIcon />
                                                </IconButton>
                                                {/*<IconButton onClick={() => handleEliminarActividad(actividad)} color="secondary">
                                                    <DeleteIcon />
                                                </IconButton>*/}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>

                {/* Tarjeta de Estudiantes del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>Estudiantes del Grupo
                            <IconButton color="primary" onClick={handleAddStudent} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                            <IconButton color="primary" onClick={handleAddStudentArray} sx={{ ml: 1 }}>
                                <PlaylistAddIcon />
                            </IconButton>
                        </Typography>
                        <TextField
                            fullWidth
                            label="Buscar estudiante"
                            variant="outlined"
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Código</TableCell>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell>Apellido</TableCell>
                                        <TableCell>Estado</TableCell>
                                        <TableCell align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filtrarEstudiantes().map((estudiante) => (
                                        <TableRow key={estudiante.id}>
                                            <TableCell>{estudiante.codigo}</TableCell>
                                            <TableCell>{estudiante.nombre}</TableCell>
                                            <TableCell>{estudiante.apellido}</TableCell>
                                            <TableCell>
                                                <FormControlLabel
                                                    control={<Switch checked={estudiante.estado} disabled />}
                                                    label={estudiante.estado ? "Activa" : "Inactiva"}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <IconButton onClick={() => handleEditStudent(estudiante)} color="primary">
                                                    <EditNoteIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleVerNotas(estudiante)} color="primary">
                                                    <GradingIcon />
                                                </IconButton>
                                                {/*<IconButton onClick={() => handleOpenDialog(estudiante)} color="secondary">
                                                    <DeleteIcon />
                                                </IconButton>*/}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
            </Grid>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ textAlign: 'center' }}
            >
                <DialogContent>
                    <WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
                    <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                        {estudianteARetirar
                            ? "¿Está seguro de retirar al estudiante del grupo?"
                            : "¿Está seguro de eliminar esta actividad?"}
                    </DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                        {estudianteARetirar
                            ? `Esta acción retirará a ${estudianteARetirar?.nombre} ${estudianteARetirar?.apellido} del grupo.`
                            : `Esta acción eliminará la actividad "${actividadAEliminar?.nombre}" del grupo.`}
                        Esta acción no se puede deshacer.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={handleCloseDialog} variant="contained" color="primary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={estudianteARetirar ? handleRetirarEstudiante : confirmarEliminarActividad}
                        variant="contained"
                        color="error"
                        autoFocus
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default GroupShow;

